
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--social icon--insta",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","class":"icon icon--social icon--insta","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"id":"Shape_1_","d":"M15 2c4.2 0 4.7 0 6.4.1 4.3.2 6.3 2.2 6.5 6.5.1 1.7.1 2.2.1 6.4s0 4.7-.1 6.4c-.2 4.3-2.2 6.3-6.5 6.5-1.7.1-2.2.1-6.4.1s-4.7 0-6.4-.1c-4.3-.2-6.3-2.2-6.5-6.5C2 19.7 2 19.2 2 15s0-4.7.1-6.4c.2-4.3 2.2-6.3 6.5-6.5C10.3 2 10.8 2 15 2z"}}),_c('circle',{staticClass:"circle__st0",attrs:{"cx":"15","cy":"15","r":"6.5"}}),_c('circle',{staticClass:"circle__st1",attrs:{"cx":"23","cy":"7","r":"1.5"}})])
          )
        }
      }
    